var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: _vm.value,
        title: "Select a Crossword Style",
        size: "xl",
        "hide-footer": "",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
        closed: function ($event) {
          return _setup.emit("input", false)
        },
      },
    },
    [
      _c(_setup.CLoader, {
        attrs: { "full-size": false, text: "Loading styles..." },
        model: {
          value: _setup.loading,
          callback: function ($$v) {
            _setup.loading = $$v
          },
          expression: "loading",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "styles-grid" },
        [
          _c(
            _setup.CButton,
            {
              staticClass: "style-thumbnail p-0",
              attrs: { variant: "empty" },
              on: {
                click: function ($event) {
                  return _setup.emit("create-custom")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/angular-app/images/template/crossword-custom-style.png"),
                  alt: "Custom Style",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Custom Style")]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_setup.presets, function (preset) {
            return _c(
              _setup.CButton,
              {
                key: preset.presetId,
                staticClass: "style-thumbnail p-0",
                class: { added: _setup.isAdded(preset) },
                attrs: { variant: "empty", disabled: _setup.isAdded(preset) },
                on: {
                  click: function ($event) {
                    return _setup.handleSelect(preset)
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: _setup.thumbnailUrl(preset), alt: preset.name },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(preset.name))]),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }